<div class="cont-escritorio hidden lg:block pb-5">
  <div class="row">
    <div class="col-6 px-0">
      <img
        src="../../../assets/images/concursos/mesDelCamionero24/FOTO-PREMIO-ESCRITORIO WEB.webp"
        style="width: 100%"
      />
    </div>

    <div class="col-6">
      <div class="p-3 mt-4">
        <div class="body-form">
          <h2 class="text-center">Completa todos los campos</h2>
          <hr class="mb-4" />
          <form [formGroup]="formulario">
            <div class="row">
              <div class="col-5">Nombre y apellido:</div>
              <div class="col-7">
                <div class="form-group">
                  <input
                    type="text"
                    formControlName="nombre"
                    class="form-control"
                    autocomplete="off"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-5">
                Rut:
                <small style="font-size: 70%">(Sin puntos y con guión)</small>
              </div>
              <div class="col-7">
                <div class="form-group">
                  <input
                    type="text"
                    formControlName="rut"
                    class="form-control"
                    autocomplete="off"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-5">Email:</div>
              <div class="col-7">
                <div class="form-group">
                  <input
                    type="text"
                    formControlName="correo"
                    class="form-control"
                    autocomplete="off"
                    [class.error]="
                      (formulario.get('correo')?.touched ||
                        formulario.get('correo')?.dirty) &&
                      formulario.get('correo')?.invalid
                    "
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-5">Celular:</div>
              <div class="col-7">
                <div class="input-group input-group-sm">
                  <div class="input-group-prepend">
                    <span class="input-group-text">+569</span>
                  </div>
                  <input
                    type="text"
                    style="
                      border-radius: 0px 4px 4px 0px !important;
                      font-size: 1rem;
                    "
                    formControlName="celular"
                    class="form-control"
                    autocomplete="off"
                    [class.error]="
                      (formulario.get('celular')?.touched ||
                        formulario.get('celular')?.dirty) &&
                      formulario.get('celular')?.invalid
                    "
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-5">N° Boleta / Factura:</div>
              <div class="col-7">
                <div class="form-group">
                  <input
                    type="text"
                    formControlName="boletaFactura"
                    class="form-control"
                    autocomplete="off"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-5">
                Sube tu foto:<br /><small
                  style="font-size: 80%; color: #d90000"
                  >(Subir la foto de forma horizontal)</small
                >
              </div>
              <div class="col-7">
                <div class="row">
                  <div class="col-5" *ngIf="fotoUrl">
                    <img *ngIf="fotoUrl" [src]="fotoUrl" class="w-100" />
                  </div>
                  <div
                    [class.col-7]="fotoUrl"
                    [class.ps-0]="fotoUrl"
                    [class.col-12]="!fotoUrl"
                  >
                    <label
                      class="custom-file-upload flex align-items-center"
                      (click)="cargaFoto()"
                    >
                      <i
                        class="fa-regular fa-camera mx-3"
                        style="font-size: 1.7rem"
                      ></i>
                      <span *ngIf="!fotoUrl"
                        >Clic aquí para subir tu foto</span
                      >
                      <span *ngIf="fotoUrl">Modificar foto</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4 justify-content-center">
              <div class="offset-5 col-7">
                <button
                  class="btn btn-block btn-secondary w-100"
                  style="font-size: 16px; letter-spacing: 2px"
                  [disabled]="formulario.invalid || !fotoUrl"
                  [class.btn-loading]="cargando"
                  [class.disabled]="formulario.invalid || !fotoUrl"
                  (click)="enviar()"
                >
                  PARTICIPAR
                </button>
              </div>
            </div>
          </form>
          <div class="row justify-content-center mt-5 pt-3">
            <img
              src="../../../assets/images/concursos/giftcard/logo.webp"
              style="width: 200px"
            />
          </div>
          <div class="text-center mt-4">
            <span style="font-size: 70%; letter-spacing: 0px"
              >*El Rut con el que participas debe ser el mismo Rut con el que
              realizaste la compra en cualquiera de nuestros canales de
              venta.<br />Participa 1 foto por Rut. Válido hasta el 31 de julio
              de 2024. Anunciamos los ganadores el 12 de agosto en nuestras
              redes sociales.<br />Al participar, cedes los derechos de las
              imágenes para uso exclusivo de Implementos.</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div
      class="w-100 text-center text-white px-0"
      style="height: 480px; background-color: #009579"
    >
      <div class="mt-3" style="font-size: 27px">
        Ellos ya subieron su foto ¡Solo faltas tú!
      </div>
      <owl-carousel-o
        class="carouselLista"
        [options]="carouselOptions"
        appOwlPreventClick
      >
        <ng-container *ngFor="let item of participantes; let i = index">
          <ng-container *ngIf="i % 2 == 0">
            <ng-template carouselSlide>
              <div
                class="flex flex-column p-3"
                style="background-color: #009579"
              >
                <img [src]="participantes[i].foto" style="height: 120px" />
                <div
                  class="text-center text-white p-1"
                  style="background-color: #0063b9"
                >
                  {{ participantes[i].nombre | titlecase }}
                </div>
              </div>
              <div
                *ngIf="participantes[i + 1]"
                class="flex flex-column p-3"
                style="background-color: #009579"
              >
                <img [src]="participantes[i + 1].foto" style="height: 120px" />
                <div
                  class="text-center text-white p-1"
                  style="background-color: #0063b9"
                >
                  {{ participantes[i + 1].nombre | titlecase }}
                </div>
              </div>
            </ng-template>
          </ng-container>
        </ng-container>
      </owl-carousel-o>
    </div>
  </div>
</div>

<div class="cont-movil block lg:hidden">
  <div class="row">
    <div class="col-12 px-0">
      <img
        src="../../../assets/images/concursos/mesDelCamionero24/FOTO-PREMIO-MOBILE WEBP.webp"
        style="width: 100%"
      />
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="mt-4">
        <div class="body-form" style="transform: scale(0.95)">
          <h2 class="text-center">Completa todos los campos</h2>
          <hr class="mb-4" />
          <form [formGroup]="formulario">
            <div class="row">
              <div class="col-5">Nombre y apellido:</div>
              <div class="col-7">
                <div class="form-group">
                  <input
                    type="text"
                    formControlName="nombre"
                    class="form-control"
                    autocomplete="off"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-5 pe-0">
                Rut:
                <small style="font-size: 69%">(Sin puntos y con guión)</small>
              </div>
              <div class="col-7">
                <div class="form-group">
                  <input
                    type="text"
                    formControlName="rut"
                    class="form-control"
                    autocomplete="off"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-5">Email:</div>
              <div class="col-7">
                <div class="form-group">
                  <input
                    type="text"
                    formControlName="correo"
                    class="form-control"
                    autocomplete="off"
                    [class.error]="
                      (formulario.get('correo')?.touched ||
                        formulario.get('correo')?.dirty) &&
                      formulario.get('correo')?.invalid
                    "
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-5">Celular:</div>
              <div class="col-7">
                <div class="input-group input-group-sm">
                  <div class="input-group-prepend">
                    <span class="input-group-text">+569</span>
                  </div>
                  <input
                    type="text"
                    style="
                      border-radius: 0px 4px 4px 0px !important;
                      font-size: 1rem;
                    "
                    formControlName="celular"
                    class="form-control"
                    autocomplete="off"
                    [class.error]="
                      (formulario.get('celular')?.touched ||
                        formulario.get('celular')?.dirty) &&
                      formulario.get('celular')?.invalid
                    "
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-5">N° Boleta / Factura:</div>
              <div class="col-7">
                <div class="form-group">
                  <input
                    type="text"
                    formControlName="boletaFactura"
                    class="form-control"
                    autocomplete="off"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-5">
                Sube tu foto:<br /><small
                  style="font-size: 80%; color: #d90000"
                  >(Subir la foto de forma horizontal)</small
                >
              </div>
              <div class="col-7">
                <div class="row flex-column">
                  <div class="col-12" *ngIf="fotoUrl">
                    <img *ngIf="fotoUrl" [src]="fotoUrl" class="w-100" />
                  </div>
                  <div class="col-12 mt-2">
                    <label
                      class="custom-file-upload flex align-items-center"
                      (click)="cargaFoto()"
                    >
                      <i
                        class="fa-regular fa-camera mx-3"
                        style="font-size: 1.7rem"
                      ></i>
                      <span *ngIf="!fotoUrl"
                        >Clic aquí para subir tu foto</span
                      >
                      <span *ngIf="fotoUrl">Modificar foto</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4 justify-content-center">
              <div class="offset-5 col-7">
                <button
                  class="btn btn-block btn-secondary w-100"
                  style="font-size: 16px; letter-spacing: 2px"
                  [disabled]="formulario.invalid || !fotoUrl"
                  [class.btn-loading]="cargando"
                  [class.disabled]="formulario.invalid || !fotoUrl"
                  (click)="enviar()"
                >
                  PARTICIPAR
                </button>
              </div>
            </div>
          </form>
          <div class="row justify-content-center mt-5 pt-3">
            <img
              src="../../../assets/images/concursos/giftcard/logo.webp"
              style="width: 200px"
            />
          </div>
          <div class="text-center mt-5">
            <span style="font-size: 75%; letter-spacing: 0px"
              >*El Rut con el que participas debe ser el mismo Rut con el que
              realizaste la compra en cualquiera de nuestros canales de
              venta.<br />Participa 1 foto por Rut. Válido hasta el 31 de julio
              de 2024. Anunciamos los ganadores el 12 de agosto en nuestras
              redes sociales.<br />Al participar, cedes los derechos de las
              imágenes para uso exclusivo de Implementos.</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div
      class="w-100 text-center text-white px-2"
      style="height: 400px; background-color: #009579"
    >
      <div class="mt-3" style="font-size: 24px">
        Ellos ya subieron su foto <br />¡Solo faltas tú!
      </div>
      <owl-carousel-o
        class="carouselLista"
        [options]="carouselOptions"
        appOwlPreventClick
      >
        <ng-container *ngFor="let item of participantes; let i = index">
          <ng-container *ngIf="i % 2 == 0">
            <ng-template carouselSlide>
              <div
                class="flex flex-column p-3"
                style="background-color: #009579"
              >
                <img [src]="participantes[i].foto" style="height: 79px" />
                <div
                  class="text-center text-white p-1"
                  style="background-color: #0063b9"
                >
                  {{ participantes[i].nombre | titlecase }}
                </div>
              </div>
              <div
                *ngIf="participantes[i + 1]"
                class="flex flex-column p-3"
                style="background-color: #009579"
              >
                <img [src]="participantes[i + 1].foto" style="height: 79px" />
                <div
                  class="text-center text-white p-1"
                  style="background-color: #0063b9"
                >
                  {{ participantes[i + 1].nombre | titlecase }}
                </div>
              </div>
            </ng-template>
          </ng-container>
        </ng-container>
      </owl-carousel-o>
    </div>
  </div>
</div>
